import React, { useEffect, useRef, useState } from 'react'
import SubFooter from '../components/Footer/SubFooter'
import ContactStephImg from "../assets/stephcontact.png";
import * as CONSTANTS from "../CONSTANTS";

function ContactUsScreen() {

  const [processing ,setProcessing]                     = useState(false);

  const nameRef                                         = useRef();
  const subjectRef                                      = useRef();
  const emailRef                                        = useRef();
  const contactNumberRef                                = useRef();
  const descriptionRef                                  = useRef();

  useEffect(() => {
    document.title = 'Cart | Stephenson Adventures';
  },[]);
  
  const handleContactContent = async () => {
    try{
      /*
      const resTourList = await axios.get(CONSTANTS.API_URL +"tours/list/", {
          headers: {
            api_key: CONSTANTS.TOKEN_APIKEY
          }
      });
      */
    }catch(err){
      console.log(err);
    }
  }

  return (
    <div className="standard-ountline">
       <div className="standard-area">ContactUsScreen
          <div className="center-outer-page-area">
              <div className="middle-page-area">
                <img src={ContactStephImg} className="contact-image" />
                <div className="form-content">
                    <form onSubmit={handleContactContent}>
                      <div className="form-group">
                          <div className="lbl">Name*</div>
                          <input type="text" className="form-control" ref={nameRef} required />
                      </div>
                      <div className="form-group">
                          <div className="lbl">Subject*</div>
                          <input type="text" className="form-control" ref={subjectRef} required />
                      </div>
                      <div className="form-group">
                          <div className="lbl">Email*</div>
                          <input type="email" className="form-control" ref={emailRef} required />
                      </div>
                      <div className="form-group">
                          <div className="lbl">Phone Number*</div>
                          <input type="text" className="form-control" ref={contactNumberRef} required />
                      </div>
                      <div className="form-group">
                          <div className="lbl">Description</div>
                          <textarea className="form-control height-2" ref={descriptionRef}></textarea>
                      </div>
                      <div className="form-group">
                          <button className="btn btn-action">
                            SEND
                          </button>
                      </div>
                    </form>
                </div>
              </div>
          </div>
       </div>
        <SubFooter />    
    </div>
  )
}

export default ContactUsScreen